(function() {
  function init() {
    // Fix hover dropdowns
    document.querySelectorAll('[data-hover-disclosure-toggle]').forEach(function(toggle) {
      var key = toggle.getAttribute('data-hover-disclosure-toggle');
      if (!key) return;
      var disc = document.getElementById(key);
      if (!disc) return;
      function showDisc() {
        toggle.classList.add('is-visible');
        toggle.setAttribute('aria-expanded', 'true');
        disc.classList.add('is-visible');
      }
      function hideDisc() {
        toggle.classList.remove('is-visible');
        toggle.setAttribute('aria-expanded', 'false');
        disc.classList.remove('is-visible');
      }
      toggle.addEventListener('mouseenter', showDisc);
      disc.addEventListener('mouseenter', showDisc);
      toggle.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (!disc.matches(':hover') && !toggle.matches(':hover')) hideDisc();
        }, 100);
      });
      disc.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (!disc.matches(':hover') && !toggle.matches(':hover')) hideDisc();
        }, 100);
      });
    });

    // Fix hamburger menu
    var burger = document.querySelector('.mobile-menu__button--burger');
    if (!burger) return;

    // Reset aria-expanded on page load to match actual drawer state
    var drawer = document.getElementById('nav-drawer');
    if (drawer && !drawer.classList.contains('is-open')) {
      burger.setAttribute('aria-expanded', 'false');
    }

    function initCollapsibles(drawer) {
      drawer.querySelectorAll('[data-collapsible-trigger]').forEach(function(trigger) {
        if (trigger.dataset.customInit) return;
        if (!trigger.closest('#nav-drawer')) return;
        trigger.dataset.customInit = '1';
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var contentId = trigger.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          if (!content) return;
          var isExpanded = trigger.classList.contains('is-expanded');
          if (isExpanded) {
            trigger.classList.remove('is-expanded');
            trigger.setAttribute('aria-expanded', 'false');
            content.style.height = '0px';
            content.classList.remove('is-expanded');
          } else {
            trigger.classList.add('is-expanded');
            trigger.setAttribute('aria-expanded', 'true');
            var inner = content.querySelector('[data-collapsible-content]');
            content.style.height = (inner ? inner.offsetHeight : content.scrollHeight) + 'px';
            content.classList.add('is-expanded');
          }
        });
      });
    }

    function openDrawer() {
      var drawer = document.getElementById('nav-drawer');
      if (!drawer) return;
      drawer.classList.remove('cv-h');
      drawer.classList.add('is-open');
      document.body.classList.add('js-drawer-open');
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      setTimeout(function() { initCollapsibles(drawer); }, 50);
    }

    function closeDrawer() {
      var drawer = document.getElementById('nav-drawer');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('js-drawer-open');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(function() { drawer.classList.add('cv-h'); }, 300);
    }

    // Use capture phase so we run BEFORE theme's bubble-phase handler
    // stopImmediatePropagation prevents theme JS from toggling the drawer back
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.mobile-menu__button--burger')) return;
      e.stopImmediatePropagation();
      var drawer = document.getElementById('nav-drawer');
      if (!drawer) return;
      var isOpen = drawer.classList.contains('is-open');
      isOpen ? closeDrawer() : openDrawer();
    }, true);

    document.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('.drawer__close-button');
      if (closeBtn && closeBtn.getAttribute('aria-controls') === 'nav-drawer') {
        closeDrawer();
      }
    });
  }

  // Run immediately if DOM is ready, otherwise wait for DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
